module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"location":"Location","language":"Language","country":"Country"},"de":{"location":"Ort","language":"Sprache","country":"Land"}}')
  delete Component.options._Ctor
}
